import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils/state'
import ActionTypes from '../constants'
import { CalculateRolloverPayload, CalculateRolloverResponse } from '../models'

import { WALLET } from './api.routes'
import { WalletActions } from '../slices/index.slices'
import { getAllWalletThunk } from './get-all.thunk'

const restApiService: RestApiService = Container.get(RestApiService)

export const calculateRolloverThunk = createAsyncThunk(
  ActionTypes.CALCULATE_ROLLOVER,
  async (payload: CalculateRolloverPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'POST',
        endpoint: WALLET.CALCULATE_ROLLOVER,
        body: payload,
      }

      const { auth, wallet } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: CalculateRolloverResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.calculateRolloverMessage')

      if (
        response.status &&
        response.status !== 200 &&
        response.status !== 201
      ) {
        message =
          response?.message && typeof response?.message === 'string'
            ? response?.message
            : i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(
          WalletActions.setFreePlaysCalculatedAction(payload.playerId),
        )
        thunkAPI.dispatch(getAllWalletThunk(removeEmptyProp(wallet.filters)))
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.status &&
            response.status !== 200 &&
            response.status !== 201
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)
